module.exports = __webpack_public_path__ + "img/arrow_left.5370d8f5.svg";